<nav #navigationMain>
  <mat-toolbar>
    <mat-toolbar-row class="mat-toolbar-row-padding flex flex-start-stretch">
      <div class="navigation-logo flex flex-start-center max-sm:hidden" data-test-id="navigation-logo">
        <a class="flex" routerLink="/"><img alt="Logo" src="assets/images/logo-my.svg" /></a>
      </div>
      <div
        [hidden]="!activeLink"
        [ngClass]="{ navigationOpened }"
        (click)="toggleNavigation()"
        #navigationButton
        class="navigation-button flex flex-start-center"
        data-test-id="navigation-button"
      >
        {{ activeLink?.title }}
      </div>
      <div class="flex flex-end-center flex-1">
        @if (user$ | async) {
          <popover-notifications
            [lastReadTimestamp]="notificationsRequestTimestamp$ | async"
            [unseenNotificationsCounter]="totalUnseenNotifications$ | async"
            *authCan="instantNotificationFeature"
            data-test-id="navigation-popover-notifications"
          >
            <ng-template #popoverContent="cdkPortal" cdkPortal let-popover>
              <notifications
                [notifications]="notifications$ | async"
                [popoverInstance]="popover"
                data-test-id="navigation-notifications"
              ></notifications>
            </ng-template>
          </popover-notifications>
        }
        <navigation-menu [user]="currentUser" class="flex" data-test-id="navigation-navigation-menu"></navigation-menu>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <div
    [ngClass]="{ navigationOpened }"
    [@openCloseNav]="navigationOpened ? 'opened' : 'closed'"
    #navigationContainer
    class="navigation-container"
    data-test-id="navigation-navigation-container"
  >
    <navigation-content data-test-id="navigation-navigation-content"></navigation-content>
  </div>
</nav>
